import axios from '@/axiosr8'

class SectionOccupationsProvider {
  async getSectionOccupations (objectId, token, dtFrom, dtTo) {
    let result = null
    if (dtFrom && dtTo) {
      result = await axios.get('/measurements/sections/' + btoa(objectId) + '/sectionoccupationdatas?dtFrom=' + dtFrom + '&dtTo=' + dtTo, {headers: {
        token: token
      }})
    }
    return result.data
  }
  async getReference (objectId, token, dtFrom, dtTo) {
    let result = null
    if (dtFrom && dtTo) {
      result = await axios.get('/measurements/sections/sectionoccupationdatas/' + btoa(objectId) + '/reference?dtFrom=' + dtFrom + '&dtTo=' + dtTo, {headers: {
        token: token
      }})
    }
    return result.data
  }
  async getOccupiedDatas (objectId, token, dtFrom, dtTo) {
    let result = null
    if (dtFrom && dtTo) {
      result = await axios.get('/measurements/sections/' + btoa(objectId) + '/occupationdatas?dtFrom=' + dtFrom + '&dtTo=' + dtTo, {headers: {
        token: token
      }})
    }
    return result.data
  }
}

export default new SectionOccupationsProvider()



// WEBPACK FOOTER //
// ./src/providers/SectionOccupationsProvider.js